<template>
  <tr>
    <td>{{ item.id }}</td>
    <td>{{ item.product_name }}</td>
  	<td>{{ item.product_code }}</td>
    <td>{{ formatMysqlDate(item.date, 'Do MMM, YYYY') }}</td>
    <td>{{ item.factory_name }}</td>
    <td>{{ status }}</td>
    <td class="align-center justify-center layout px-0">
      <v-icon small class="mr-1" v-if="isPending" color="green" @click="$emit('confirm', item)">done</v-icon>
      <v-icon small class="mr-1" v-if="isPending" color="red" @click="$emit('cancel', item)">clear</v-icon>
      <router-link :to="`/production/${item.id}`" v-if="hasEditAccess && isPending" title="Edit Production">
        <v-icon small class="mr-1">edit</v-icon>
      </router-link>
      <router-link :to="`/production/view/${item.id}`" title="View Production">
        <v-icon small class="mr-1">visibility</v-icon>
      </router-link>
    </td>
  </tr>
</template>
<script>
export default {
  name: 'ProductionListItem' ,
  props: {
    item: {
      required: true
    }
  },
  data () {
    return {
      
    }
  },
  
  methods: {

  },

  mounted () {
  	
  },

  computed: {
    
    isPending () {
      return this.item.status == this.config.productionStatus.pending
    },

    isApproved () {
      return this.item.status == this.config.productionStatus.approved
    },

    isCancelled () {
      return this.item.status == this.config.productionStatus.cancelled
    },

    status () {
      let status = ""
      let statuses = this.config.productionStatus
      
      switch (this.item.status) {
        case statuses.pending:
          status = "Pending"
        break
        case statuses.approved:
          status = "Approved"
        break
        case statuses.cancelled:
          status = "Cancelled"
        break
      }

      return status
    }

  },

  watch: {
    
  }
}
</script>